import type { Tax } from "@packages/sdk";

import { useLineItemFormatter } from "../../../hooks/useLineItemFormatter";
import { CheckoutLineItem } from "../checkout/CheckoutLineItem";

type TaxLineItemProps = Tax & { currency: string };

export const TaxLineItem = ({ name, amount, currency }: TaxLineItemProps) => {
  const formatter = useLineItemFormatter({ currency });
  return <CheckoutLineItem label={name} value={formatter.format(amount)} />;
};
